export default {
  namespaced: true,
  state: {
    isMobile: false,
    isLkMobile: false,
    isMobileMenuVisible: false,

    isTablet: false,
    isTabletHeader: false,
    isTabletMenuVisible: false,
    currentSubmenuIndex: null,
  },
  getters: {
    isVisibleSubmenu: state => index => {
      return state.currentSubmenuIndex == index
    },
  },
  mutations: {
    toggleMobileMenu(state) {
      if (state.isMobile) {
        state.isMobileMenuVisible = !state.isMobileMenuVisible
        state.currentSubmenuIndex = null
      } else {
        state.isTabletMenuVisible = !state.isTabletMenuVisible
        state.currentSubmenuIndex = null
      }
    },

    setMobileState(state, value) {
      state.isMobile = value
    },

    setLkMobileState(state, value) {
      state.isLkMobile = value
    },
    setVisibleMobileMenu(state) {
      state.isMobileMenuVisible = true
    },
    setHiddenMobileMenu(state) {
      state.currentSubmenuIndex = null
      state.isMobileMenuVisible = false
    },
    setActiveSubmenuIndex(state, index) {
      const idx = parseInt(index)

      if (idx === state.currentSubmenuIndex) {
        state.currentSubmenuIndex = null
      } else state.currentSubmenuIndex = idx
    },

    // Tablet menu

    setTabletState(state, value) {
      state.isTablet = value
    },
    setTabletHeaderState(state, value) {
      state.isTabletHeader = value
    },
    setVisibleTabletMenu(state) {
      state.isTabletMenuVisible = true
    },
    setHiddenTabletMenu(state) {
      state.currentSubmenuIndex = null
      state.isTabletMenuVisible = false
    },
    setActiveTabletSubmenuIndex(state, index) {
      state.currentSubmenuIndex = parseInt(index)
    },
  },
}



// WEBPACK FOOTER //
// ./src/legacy/store/modules/mobile.js